import { useEffect, useState } from 'react';
import { number, bool } from 'prop-types';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import { mapState } from './selectors';

import * as paths from '../../config/paths';
import styled from 'styled-components';
import { colors } from '@podiumhq/podium-ui';

import { useFetchCurrentUser } from '../../api/users/queries';
import { useRolePermissions } from '../../api/permissions/queries';
import withGetDefaultPermissions from './apollo/withGetDefaultPermissions';

import ViewDefault from './ViewDefault';
import ViewScaled from './ViewScaled';

Header.propTypes = {
  partnerId: number,
  canUseRogbot: bool,
  canViewIntegrations: bool,
};

Header.defaultProps = {
  partnerId: null,
  canUseRogbot: false,
  canViewIntegrations: false,
  skyhookCanAccessMarketplace: false,
  skyhookCanUseRogbot: false,
  skyhookCanViewFlock: false,
  skyhookCanViewPartner: true,
  skyhookCanReadIntegrationsList: false,
};

function Header(props) {
  const location = useLocation();
  const { currentUser } = useFetchCurrentUser();
  const { rolePermissions } = useRolePermissions();

  const handleIsScaled = () => window.innerWidth <= 978;
  const [isScaled, setIsScaled] = useState(handleIsScaled());

  useEffect(() => {
    const onResize = () => {
      setIsScaled(handleIsScaled());
    };
    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  const isLocationHome = location.pathname === paths.HOME;

  return (
    <Container>
      {isScaled ? (
        <ViewScaled
          props={props}
          location={location}
          currentUser={currentUser}
          rolePermissions={rolePermissions}
          isLocationHome={isLocationHome}
        />
      ) : (
        <ViewDefault
          props={props}
          location={location}
          currentUser={currentUser}
          rolePermissions={rolePermissions}
          isLocationHome={isLocationHome}
        />
      )}
    </Container>
  );
}

const Container = styled.div`
  padding: 0 87px;
  background: ${colors.mineShaft};
  @media (max-width: 1064px) {
    padding: 0 40px;
  }
`;

export default compose(connect(mapState), withGetDefaultPermissions)(Header);
